import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

//i18n
import { withTranslation } from 'react-i18next'

class QualityContent extends Component {
	constructor(props) {
		super(props)
		this.refDiv = React.createRef()
	}

	render() {
		const { t } = this.props

		return (
			<React.Fragment>
				<li>
					<Link to="/#" className="has-arrow">
						<i className="bx bxs-vial" />
						<span>{t('quality', { ns: 'naming' })}</span>
					</Link>
					<ul className="sub-menu" aria-expanded="false">
						<li>
							<Link to="/verification">
								{t('verification', { ns: 'naming' })}
							</Link>
						</li>
						<li>
							<Link to="/incidences">{t('incidences', { ns: 'naming' })}</Link>
						</li>
					</ul>
				</li>
			</React.Fragment>
		)
	}
}

QualityContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
	type: PropTypes.string,
	initMenu: PropTypes.func,
}

export default withRouter(withTranslation()(QualityContent))
